module.exports = __webpack_public_path__ + "img/qxdj_logo.fcd39ab9.png";